import React from 'react';
import './rightPanel.scss';

interface OwnProps {
  isOpened: boolean;
  content: JSX.Element | string;
}

type Props = OwnProps;

const RightPanel: React.FC<Props> = (props) => {
  return (
    <div className="spliter">
      <div className="spliter_mainpanel">{props.children}</div>
      <div className="spliter_rightpanel">{props.content}</div>
    </div>
  );
};

export default RightPanel;
